// Copyright 2025, University of Maryland, All Rights Reserved
import { useEffect, useState } from 'react';

export default function DebugIndicator() {
  const [isDebugMode, setIsDebugMode] = useState(false);
  
  useEffect(() => {
    // Check if debug mode is enabled in sessionStorage
    const debugModeEnabled = sessionStorage.getItem('debugModeEnabled') === 'true';
    setIsDebugMode(debugModeEnabled);
    
    // Listen for storage changes
    const handleStorageChange = () => {
      const debugModeEnabled = sessionStorage.getItem('debugModeEnabled') === 'true';
      setIsDebugMode(debugModeEnabled);
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
  
  if (!isDebugMode) return null;
  
  return (
    <div 
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        padding: '5px 10px',
        backgroundColor: 'rgba(255, 100, 0, 0.8)',
        color: 'white',
        borderRadius: '4px',
        fontSize: '12px',
        zIndex: 9999
      }}
    >
      Debug Mode Active
    </div>
  );
}